<template>
	<div class="sa-list-component">
		<div class="sa-list-component-header">
			<b-row class="mb-5 align-items-center bg-white p-4 rounded shadow-sm mx-0 border-bottom border-primary">
				<b-col md="6">
					<h2 class="h4 mb-1 font-weight-bold text-dark">Storico Contabile</h2>
					<p class="text-muted small mb-0">Monitoraggio flussi finanziari e scadenze pagamenti</p>
				</b-col>
				<b-col md="6" class="text-right">
					<div class="d-inline-block px-4 border-right text-center">
						<span class="sa-articolo-label-mini text-danger">Totale Debito</span>
						<span class="h4 font-weight-bold text-danger">€ {{ totaleDebito }}</span>
					</div>
					<div class="d-inline-block px-4 text-center">
						<span class="sa-articolo-label-mini text-success">Valore Stock</span>
						<span class="h4 font-weight-bold text-success">€ {{ valoreMagazzino }}</span>
					</div>
				</b-col>
			</b-row>
		</div>
		<div class="sa-list-component-body">
			<div class="sa-articolo-timeline-contabile">
				<div v-for="(mov, index) in movimenti" :key="index" class="sa-articolo-timeline-item">
					<div :class="['sa-articolo-dot', getStatusClass(mov.stato)]">
						<i :class="getStatusIcon(mov.stato)"></i>
					</div>

					<b-card no-body class="sa-articolo-card-contabile">
						<b-card-body class="p-4">
							<b-row align-v="center">
								<b-col md="5">
									<span class="sa-articolo-label-mini text-primary">{{ mov.data }}</span>
									<h5 class="mb-1 font-weight-bold text-dark">{{ mov.causale }}</h5>
									<p class="mb-0 text-muted small">
										<i class="fas fa-file-invoice mr-1"></i> Doc: <strong>{{ mov.documento }}</strong
										><br />
										<i class="fas fa-building mr-1"></i> Fornitore: {{ mov.soggetto }}
									</p>
								</b-col>

								<b-col md="3" class="border-left">
									<span class="sa-articolo-label-mini">Logistica</span>
									<span class="d-block text-dark"
										>Q.tà: <strong>{{ mov.quantita }}</strong></span
									>
									<span class="d-block text-muted text-xs">Prezzo Unit: € {{ mov.prezzoUnit.toFixed(2) }}</span>
								</b-col>

								<b-col md="4" class="text-right border-left">
									<span class="sa-articolo-label-mini">Importo Totale</span>
									<div class="sa-articolo-price-tag mb-2">€ {{ (mov.quantita * mov.prezzoUnit).toFixed(2) }}</div>

									<b-badge :variant="getBadgeVariant(mov.stato)" pill class="px-3 py-2 clickable-badge" @click="mov.showPayments = !mov.showPayments">
										{{ mov.stato }}
										<i v-if="mov.transazioni.length" class="fas ml-2" :class="mov.showPayments ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
									</b-badge>
								</b-col>
							</b-row>

							<b-row v-if="mov.stato !== 'SCADUTO'" class="mt-4">
								<b-col>
									<div class="d-flex justify-content-between mb-1 text-xs font-weight-bold">
										<span class="text-success">Pagato: € {{ mov.pagato.toFixed(2) }}</span>
										<span class="text-danger">Residuo: € {{ (mov.quantita * mov.prezzoUnit - mov.pagato).toFixed(2) }}</span>
									</div>
									<b-progress :value="mov.pagato" :max="mov.quantita * mov.prezzoUnit" :variant="mov.stato === 'SALDATO' ? 'success' : 'warning'" height="8px" animated></b-progress>
								</b-col>
							</b-row>
						</b-card-body>

						<b-collapse v-model="mov.showPayments">
							<div class="sa-articolo-payment-detail">
								<h6 class="sa-articolo-label-mini text-primary mb-3">Cronologia Transazioni Effettuate</h6>

								<div v-if="mov.transazioni.length > 0">
									<div v-for="(tr, tIdx) in mov.transazioni" :key="tIdx" class="sa-articolo-pagamento-line">
										<div>
											<i class="fas fa-receipt text-muted mr-2"></i>
											<strong>{{ tr.data }}</strong>
											<span class="text-muted ml-2 small">({{ tr.metodo }})</span>
										</div>
										<div class="text-success font-weight-bold">+ € {{ tr.importo.toFixed(2) }}</div>
									</div>
								</div>
								<div v-else class="text-center py-3 text-muted small italic"><i class="fas fa-info-circle mr-2"></i>Nessun pagamento ancora registrato per questo documento.</div>
							</div>
						</b-collapse>
					</b-card>
				</div>
			</div>
		</div>
		<div class="sa-list-component-footer"></div>
	</div>
</template>

<script>
import UtilityMixin from "../../utility/UtilityMixin";
// import ModalError from "../../../template/components/modal/components/ModalError.vue";

import moment from "moment";
export default {
	name: "MagazzinoArticoliStoricoContabileComponent",
	mixins: [UtilityMixin],
	props: {},
	components: {},

	mounted() {
		// let me = this;
	},
	data() {
		return {
			totaleDebito: "1.250,00",
			valoreMagazzino: "12.400,00",
			movimenti: [
				{
					data: "22 Mar 2026",
					causale: "ACQUISTO STOCK",
					documento: "FAT-2026-001",
					soggetto: "GLOBAL PHARMA SRL",
					quantita: 50,
					prezzoUnit: 25.0,
					stato: "SCADUTO",
					pagato: 0,
					showPayments: false,
					transazioni: [],
				},
				{
					data: "10 Mar 2026",
					causale: "RIFORNIMENTO MENSILE",
					documento: "FAT-2026-088",
					soggetto: "MED SUPPLIES",
					quantita: 20,
					prezzoUnit: 22.5,
					stato: "PARZIALE",
					pagato: 200.0,
					showPayments: false,
					transazioni: [
						{ data: "15 Mar 2026", importo: 150.0, metodo: "Bonifico Bancario" },
						{ data: "28 Mar 2026", importo: 50.0, metodo: "Assegno Circolare" },
					],
				},
				{
					data: "01 Feb 2026",
					causale: "ACQUISTO URGENTE",
					documento: "FAT-2026-012",
					soggetto: "GLOBAL PHARMA SRL",
					quantita: 10,
					prezzoUnit: 28.0,
					stato: "SALDATO",
					pagato: 280.0,
					showPayments: false,
					transazioni: [{ data: "05 Feb 2026", importo: 280.0, metodo: "Ri.Ba. 30gg" }],
				},
			],
		};
	},
	methods: {
		init(filtro) {
			if (filtro) {
				this.filtro = filtro;
			}
			this.loadStoricoContabilitaArticolo();
		},
		loadStoricoContabilitaArticolo() {
			let me = this;
			UtilityMixin.methods.loadDataResources(me.pathResouce, this.filtro, me.loadStoricoContabilitaArticoloSuccess, me.loadStoricoContabilitaArticoloError);
		},

		loadStoricoContabilitaArticoloSuccess(response) {
			let me = this;
			me.rows = response.data.data.recordsNumber;
			me.storicoItems = response.data.data.list;
		},
		loadStoricoContabilitaArticoloError(error) {
			console.log(error);
			this.$bvToast.toast("Attenzione", {
				title: "Errore",
				variant: "danger",
				solid: true,
			});
		},
		getData(value) {
			return moment(new Date(value)).format("DD/MM/YYYY");
		},
		getDescrizioneOperazioneContabile(operazione) {
			if (operazione == 0) {
				return "INVARIATO";
			} else if (operazione > 0) {
				return "AVERE";
			} else if (operazione < 0) {
				return "DARE";
			}
		},
		onSubmit() {
			let dateFilter = this.$refs.cmpDateFilterComponent.getFilter();
			this.filtro.dataDal = dateFilter.dataDal;
			this.filtro.dataAl = dateFilter.dataAl;
			this.loadStoricoContabilitaArticolo();
		},
		onReset() {},
		getStatusClass(stato) {
			switch (stato) {
				case "SALDATO":
					return "sa-articolo-dot-saldato";
				case "PARZIALE":
					return "sa-articolo-dot-parziale";
				case "SCADUTO":
					return "sa-articolo-dot-scaduto";
				default:
					return "";
			}
		},
		getStatusIcon(stato) {
			switch (stato) {
				case "SALDATO":
					return "fas fa-check";
				case "PARZIALE":
					return "fas fa-hand-holding-usd";
				case "SCADUTO":
					return "fas fa-exclamation-triangle";
				default:
					return "fas fa-file";
			}
		},
		getBadgeVariant(stato) {
			switch (stato) {
				case "SALDATO":
					return "success";
				case "PARZIALE":
					return "warning";
				case "SCADUTO":
					return "danger";
				default:
					return "secondary";
			}
		},
	},
};
</script>
<style scoped>
.sa-articolo-wrapper {
	background-color: #f4f7f6;
	min-height: 100vh;
	padding: 2rem 0;
	font-family: "Inter", sans-serif;
}

/* Timeline Linea Verticale */
.sa-articolo-timeline-contabile {
	position: relative;
	padding: 20px 0;
}
.sa-articolo-timeline-contabile::before {
	content: "";
	position: absolute;
	top: 0;
	bottom: 0;
	left: 31px;
	width: 2px;
	background: #dee2e6;
}

.sa-articolo-timeline-item {
	position: relative;
	margin-bottom: 30px;
	padding-left: 70px;
}

/* Punto di snodo sulla timeline */
.sa-articolo-dot {
	position: absolute;
	left: 20px;
	top: 15px;
	width: 26px;
	height: 26px;
	border-radius: 50%;
	background: #fff;
	border: 2px solid #ced4da;
	z-index: 2;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 0.75rem;
	box-shadow: 0 0 0 4px #f4f7f6;
}

/* Colori Stati Pagamento */
.sa-articolo-dot-saldato {
	border-color: #28a745;
	color: #28a745;
}
.sa-articolo-dot-parziale {
	border-color: #ffc107;
	color: #ffc107;
}
.sa-articolo-dot-scaduto {
	border-color: #dc3545;
	color: #dc3545;
}

/* Card Contabile */
.sa-articolo-card-contabile {
	border: none;
	border-radius: 12px;
	box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
	transition: all 0.3s ease;
	overflow: hidden;
}
.sa-articolo-card-contabile:hover {
	transform: translateY(-2px);
	box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
}

.sa-articolo-label-mini {
	font-size: 0.65rem;
	text-transform: uppercase;
	font-weight: 800;
	color: #94a3b8;
	display: block;
	letter-spacing: 0.5px;
}
.sa-articolo-price-tag {
	font-size: 1.25rem;
	font-weight: 800;
	color: #1e293b;
}

/* Area Dettaglio Pagamenti Espandibile */
.sa-articolo-payment-detail {
	background-color: #f8fafc;
	border-top: 1px solid #e2e8f0;
	padding: 1.5rem;
}
.sa-articolo-pagamento-line {
	display: flex;
	justify-content: space-between;
	padding: 8px 0;
	border-bottom: 1px solid #edf2f7;
	font-size: 0.9rem;
}
.sa-articolo-pagamento-line:last-child {
	border-bottom: none;
}

.clickable-badge {
	cursor: pointer;
	user-select: none;
}
.text-xs {
	font-size: 0.75rem;
}
</style>
